<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Άδειες</h4>
          <p class="card-title-desc">
            Επεξεργασία και προσθήκη Άδειας Προσωπικού. Εφαρμόζεται μόνο αν το
            <strong>
              <router-link
                :to="{ name: 'hrms' }"
                custom
                v-slot="{ navigate, href }"
              >
                <a :href="href" @click="navigate">Hrms</a>
              </router-link>
            </strong>
            είναι ανενεργό.
          </p>

          <!-- <b-tabs
            justified
            nav-class="nav-tabs-custom"
            content-class="p-3 text-muted"
          > -->
          <b-tabs content-class="p-3 text-muted">
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">Τύπος Άδειας</span>
              </template>
              <!-- TABLE WITH HOLIDAY TYPES -->
              <div class="row">
                <div class="col-xl-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Τύποι Άδειας</h4>
                      <p class="card-title-desc">
                        <b-alert
                          v-if="alertSchema.show"
                          show
                          dismissible
                          :variant="alertSchema.alertVariant"
                          >{{ alertSchema.alertMsg }}</b-alert
                        >
                      </p>

                      <div class="table-responsive">
                        <table class="table mb-0">
                          <thead class="table-light">
                            <tr>
                              <th>Α/Α</th>
                              <th>Τυπος Αδειας</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(type, index) in holidayTypes"
                              :key="index"
                            >
                              <th scope="row">{{ index + 1 }}</th>
                              <td>{{ type.title }}</td>
                              <td>
                                <i
                                  class="mdi mdi-pencil"
                                  @click.prevent="$bvModal.show(type.title)"
                                ></i>
                                <i
                                  class="mdi mdi-trash-can"
                                  @click.prevent="confirm(type.id)"
                                ></i>

                                <b-modal
                                  :id="type.title"
                                  ref="modal"
                                  title="Επεξεργασία Τύπος Άδειας"
                                  centered
                                  hide-footer
                                >
                                  <FormModal
                                    cardTitle="Επεξεργασία Τύπος Άδειας"
                                    description=""
                                    :value="type.title"
                                    action="update"
                                    @formData="parseFormData"
                                    :holidayTypeID="type.id"
                                  ></FormModal>
                                </b-modal>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" v-b-modal.addHolidayType>
                Προσθήκη
              </button>
              <b-modal
                id="addHolidayType"
                title="Προσθήκη νέου τύπου άδειας"
                centered
                hide-footer
              >
                <FormModal
                  cardTitle="Προσθήκη τύπου άδειας"
                  description="Εισάγετε ένα νέο τίτλο"
                  value=""
                  action="add"
                  @formData="parseFormData"
                >
                </FormModal>
              </b-modal>

              <!-- END OF TABLE WITH HOLIDAY TYPES -->
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="far fa-user"></i>
                </span>
                <span class="d-none d-sm-inline-block">Τρέχουσες Άδειες</span>
              </template>
              <div class="row">
                <div class="col-xl-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Τρέχουσες Άδειες</h4>
                      <p class="card-title-desc"></p>

                      <div class="table-responsive">
                        <table class="table mb-0">
                          <thead class="table-light">
                            <tr>
                              <th>A/A</th>
                              <th>Όνομα</th>
                              <th>Από</th>
                              <th>Έως</th>
                              <th>Τύπος Αδειας</th>
                            </tr>
                          </thead>

                          <tbody v-if="hrmsIsEnable">
                            <tr
                              v-for="(name, index) in peopleLeaves"
                              :key="index"
                            >
                              <th scope="row">{{ index + 1 }}</th>
                              <td>{{ name.person }}</td>
                              <td v-if="name && name.hrms">
                                {{ name.hrms.from_leave_date.split("T")[0] }}
                              </td>
                              <td v-if="name && name.hrms">
                                {{ name.hrms.to_leave_date.split("T")[0] }}
                              </td>
                              <td v-if="name && name.hrms">
                                {{ name.hrms.lty_descr }}
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr
                              v-for="(name, index) in peopleHolidays"
                              :key="index"
                            >
                              <th scope="row">{{ index + 1 }}</th>
                              <td>{{ name.person_full_name }}</td>
                              <td>
                                {{
                                  name.holidays_start_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                }}
                              </td>
                              <td>
                                {{
                                  name.holidays_end_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                }}
                              </td>
                              <td>
                                {{ name.holiday_type_name }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import session from "../../../../api/session";
import FormModal from "./form-modal.vue";
import Swal from "sweetalert2";
export default {
  page: {
    title: "Άδειες Προσωπικού",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    FormModal,
  },
  data() {
    return {
      title: "Αδειες",
      items: [
        {
          text: "Προσωπικό",
          to: { name: "staff-users" },
        },
        {
          text: "Άδειες Προσωπικού",
          active: true,
        },
      ],
      hrmsIsEnable: false,
      holidayTypes: [],
      alertSchema: {
        show: false,
        alertVariant: "",
        alertMsg: "",
      },
      peopleLeaves: [],
      peopleHolidays: [],
    };
  },
  mounted() {
    this.fetchHrms();
    this.fetchHolidayTypes();
    this.fetchPeopleHolidays();
  },
  methods: {
    fetchPeopleHolidays() {
      session.get(`api/people/holidays/?on_holidays=true`).then((resp) => {
        this.peopleHolidays = resp.data;
      });
    },
    fetchLeavesFromHrms() {
      session.get("api/hrms/hrms-leave-list/").then((resp) => {
        this.peopleLeaves = resp.data;
      });
    },
    fetchHrms() {
      session.get("api/hrms/hrms-list/").then((resp) => {
        if (resp.data.length > 0) {
          this.hrmsIsEnable = resp.data[0].is_active;
        }
      });

      this.fetchLeavesFromHrms();
    },

    fetchHolidayTypes() {
      session
        .get("api/holidays/holiday-type-list/")
        .then((resp) => {
          this.holidayTypes = resp.data;
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },

    holidaysTypeUpdate(value, holidayID) {
      this.$refs["modal"][0].hide();

      session
        .put(`api/holidays/holiday-type/${holidayID}/action/`, {
          title: value,
        })
        .then(() => {
          this.alertSchema = {
            alertVariant: "success",
            alertMsg: "Ο τύπος Αδειας ανανεώθηκε",
            show: true,
          };
          this.fetchHolidayTypes();
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },

    holidayTypeCreate(value) {
      session
        .post("api/holiday-type/create/", {
          title: value,
        })
        .then(() => {
          this.alertSchema = {
            alertVariant: "success",
            alertMsg: "Ο τύπος Αδειας Προστέθηκε",
            show: true,
          };
          this.$bvModal.hide("addHolidayType");
          this.fetchHolidayTypes();
        })
        .catch((e) => {
          this.alertSchema = {
            alertVariant: "danger",
            alertMsg: e.response.data,
            show: true,
          };
        });
    },

    parseFormData(value, action, holidayID) {
      console.log(value, action, holidayID);
      if (action === "update") {
        this.holidaysTypeUpdate(value, holidayID);
      }
      if (action === "add") {
        this.holidayTypeCreate(value);
      }
    },
    deleteHolidayType(holidayID) {
      session
        .delete(`api/holidays/holiday-type/${holidayID}/action/`)
        .then(() => {
          this.fetchHolidayTypes();
        });
    },
    confirm(holidayType) {
      Swal.fire({
        title: "Είστε σίγουρος;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          this.deleteHolidayType(holidayType);
          Swal.fire(
            "Διαγράφηκε!",
            "O τύπος άδειας σας έχει διαγραφεί.",
            "success"
          );
        }
      });
    },
  },
};
</script>

<style scoped>
.mdi-pencil {
  padding: 10px;
  color: rgb(224, 151, 15);
  transition: all 0.4s;
  margin-right: 5px;
}
.mdi-trash-can {
  color: red;
  padding: 10px;
  transition: all 0.6s;
}
.mdi-pencil {
  color: rgb(224, 151, 15);
  cursor: pointer;
  font-size: 20px;
}
.mdi-trash-can {
  color: red;
  cursor: pointer;
  font-size: 20px;
}
</style>
